import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { TamSplitterComponent } from './tam-splitter/tam-splitter.component';
import { TamSplitterPanelComponent } from './tam-splitter-panel/tam-splitter-panel.component';
import { TamSplitterBarComponent } from './tam-splitter-bar/tam-splitter-bar.component';

@NgModule({
    declarations: [
        TamSplitterComponent,
        TamSplitterPanelComponent,
        TamSplitterBarComponent
    ],
    imports: [
        BrowserModule,
    ],
    exports: [TamSplitterComponent,
        TamSplitterPanelComponent,
        TamSplitterBarComponent
    ]
})
export class TamModule { }
